<style>
/* @import "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"; */
#employee_data_length label,
#employee_data_filter label {
  display: flex;
  align-items: center;
}
#employee_data_length {
  float: left;
}
#employee_data_filter,
#employee_data_paginate {
  float: right;
}
.container {
  margin-top: 80px;
}
#employee_data_paginate ul li {
  padding: 7px;
}
#employee_data {
  margin-top: 10px;
}
#data .odd {
  display: none;
}
.reviewvideo a {
  color:#0d6efd !important;
}
#back1{
  margin-bottom:10px;
  float: left;
}
</style>

<template>
  <div class="reviewvideo">
    <div class="container">
      <!-- <input
        type="button"
        class="btn btn-primary btnconnection"
        id="startMission"
        name="startMission"
        :value="$t('message.startmission', {}, { locale: lang })"
        v-on:click="test"
      /> -->
      <input
        type="button"
        :value="$t('message.back', {}, { locale: lang })"
        class="btn btn-primary"
        id="back1"
        name="back"
        v-on:click="backToCheckMission"
      />
      <table
        class="table table-striped table-bordered table-list"
        style="overflow-x: scroll"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("message.mission", {}, { locale: lang }) }}</th>
            <th>{{ $t("message.user", {}, { locale: lang }) }}</th>
            <th>{{ $t("message.point", {}, { locale: lang }) }}</th>
            <th>{{ $t("message.timeRun", {}, { locale: lang }) }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="data"></tbody>
      </table>
      <strong id="notifi"></strong>
      <nav aria-label="Page navigation example">
        <ul class="pagination"></ul>
      </nav>
    </div>
  </div>
</template>

<script>
import callFunction from "../../../public/common/vue/api/leanbot_js_api";
import $ from "jquery";
import WebsocketLeanbot from "../../../public/common/vue/api/leanbot.websocket";
import * as paho_mqtt from "paho-mqtt";
import { reviewLink, reviewRow } from "./review-rows";
// import conf from "../../../public/config/vue/config.js";

export default {
  data() {
    return {
      lang: "en",
      review : 'Review',
      unavailable: 'Not available'
    };
  },
  mounted() {
    // #576: no scripts from other origins (the CSP's script-src 'self' blocks them); the
    // rows, links and pagination use the jQuery imported above.
    if (sessionStorage.getItem("lang") == "vi") {
      this.lang = "vi";
      this.review = 'Xem lại';
      this.unavailable = 'Không xem lại được';
    } else {
      this.lang = "en";
      this.review = 'Review';
      this.unavailable = 'Not available';
    }
    if (sessionStorage.getItem("lessionCode") == null) {
      if(this.lang == 'vi'){
        $("#notifi").append("Không có dữ liệu để hiển thị");
      }else{
        $("#notifi").append("No data to display");
      }
    } else {
      var results_per_page = 10;

      const url1 = conf.api.video_url + "/get";
      var method1 = "GET";
      var jsonBody1 = JSON.stringify({
        func: "19",
        body: {
          nguoitao: sessionStorage.getItem("USERNAME"),
          ojectpk: sessionStorage.getItem("lessionCode"),
        },
      });
      var jsonRequest1 = btoa(jsonBody1);
      var getData1 = function (resp) {
        var number_of_result = resp["data"];
        var number_of_page = Math.ceil(number_of_result / results_per_page);
        var page;
        if (this.$route.query.page == null) {
          page = 1;
        } else {
          page = this.$route.query.page;
        }
        var page_first_result = (page - 1) * results_per_page;

        const url2 = conf.api.video_url + "/get";
        var method2 = "GET";
        var jsonBody2 = JSON.stringify({
          func: "105",
          body: {
            nguoitao: sessionStorage.getItem("USERNAME"),
            ojectpk: sessionStorage.getItem("lessionCode"),
            perpage: results_per_page,
            page: page,
          },
        });
        var jsonRequest2 = btoa(jsonBody2);
        var getData2 = function (resp) {
          console.log(resp);
          if(resp.data == ''){
            if(this.lang == 'vi'){
              $("#notifi").append("Không có dữ liệu để hiển thị");
            }else{
              $("#notifi").append("No data to display");
            }
          }
          // console.log(resp["data"]);
          // #576: rows are DOM nodes with the server's values as text, and a link only
          // to a supported review route (review-rows.ts).
          var urlView = null;
          try {
            urlView = localStorage.getItem("url_view");
          } catch (e) {
            urlView = null;
          }
          var lang = sessionStorage.getItem("lang");
          var labels = { review: this.review, unavailable: this.unavailable };
          var arrayLength = resp["data"].length;
          for (var i = 0; i < arrayLength; i++) {
            var record = resp["data"][i] || {};
            var link = reviewLink(urlView, record, lang, window.location.origin);
            $("#data").append(reviewRow(document, i, record, link, labels));
          }
          if (page > 3) {
            var firstpage = 1;
            $(".pagination").append(`
                <li class="page-item"><a class="page-link" href="?page=${firstpage}">First</a></li>
            `);
          }

          for (let num = 1; num <= number_of_page; num++) {
            if (num != page) {
              if (num > page - 3 && num < page + 3) {
                $(".pagination").append(`
                    <li class="page-item"><a class="page-link" href="?page=${num}">${num}</a></li>
                `);
              }
            } else {
              $(".pagination").append(`
                <strong class="current-page page-item" style="padding: 9px 14px;line-height: 1.25;background: #000;color: #fff;">${num}</strong>
            `);
            }
          }

          if (page < number_of_page - 3) {
            var endpage = number_of_page;
            $(".pagination").append(`
                <li class="page-item"><a class="page-link" href="?page=${endpage}">Last</a></li>
            `);
          }
        }.bind(this);
        callFunction(url2, method2, jsonRequest2, getData2);
      }.bind(this);
      callFunction(url1, method1, jsonRequest1, getData1);
    }
  },
  methods: {
    backToCheckMission(){
      // window.location.href =
      //   window.location.origin + "/#/?lang=" + this.lang;
       window.location.href =
        window.location.origin;
    },
  },
};
</script>
